'use client'
import React, { useEffect, useMemo, useState } from 'react'

import { Footer } from './footer'

const FooterWrapper: React.FC = () => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    // Use a fixed year for SSR to prevent hydration mismatches
    const currentYear = useMemo(() => {
        if (!isClient) {
            return 2025 // Fixed year for SSR
        }
        return new Date().getFullYear()
    }, [isClient])

    return <Footer currentYear={currentYear} />
}

export { FooterWrapper }
export default FooterWrapper
